import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { withSnackbar } from 'notistack';

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from '@material-ui/core/Card';
import Slide from "@material-ui/core/Slide";

const Confirmation = (props) => {
    const {formData} = props;

    useEffect(() => {
        props.enqueueSnackbar('Sign up successful', {
            variant: "success",
            autoHideDuration: 6000,
            TransitionComponent: Slide,
            anchorOrigin: {vertical: 'bottom', horizontal: 'right'}
        });
    }, [props]);

    if (!props.formData) {
        return <Redirect to={"/"}/>
    }

    const formattedStart = new Date(formData.date + "T" + formData.startTime).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    });

    const formattedEnd = new Date(formData.date + "T" + formData.endTime).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    });
    const formattedDate = new Date(formData.date + "T17:00").toDateString();

    return (
        <Grid container style={{textAlign: 'center', marginTop: '10%'}}>
            <Grid item sm={10} md={8} lg={6} style={{marginRight: 'auto', marginLeft: 'auto', padding: '5px'}}>
                <Slide in={true} {...{timeout: 500}}>
                    <Card style={{backgroundColor: 'blue', color: 'white', padding: '5px'}}>
                        <Typography variant={"h3"} style={{color: 'yellow'}}>Sign up summary:</Typography>
                        <Typography>You signed up for <span style={{fontWeight: 'bold'}}>{formData.eventName}</span> as
                            a <span
                                style={{fontWeight: 'bold'}}>{formData.position}</span></Typography>
                        <Typography>This event takes place from <span
                            style={{fontWeight: 'bold'}}>{formattedStart}</span> to <span
                            style={{fontWeight: 'bold'}}>{formattedEnd}</span> on <span
                            style={{fontWeight: 'bold'}}>{formattedDate}</span></Typography>
                        {formData.details && <Typography>Extra event information: {formData.details}</Typography>}
                    </Card>
                </Slide>
            </Grid>
        </Grid>
    );
};

const mapStateToProps = state => {
    return {
        formData: state.signUp.data
    };
};

export default connect(mapStateToProps)(withSnackbar(Confirmation));
